const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()
const PNF = require('google-libphonenumber').PhoneNumberFormat

export const phoneNumber = (value: string): string => {
  const number = phoneUtil.parse(value)
  return phoneUtil.formatOutOfCountryCallingNumber(number, PNF.INTERNATIONAL)
}
